"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonsWeblabTaskClient = void 0;
var KatalWeblabSellerCentralClient_1 = require("./KatalWeblabSellerCentralClient");
/**
 * Driver for KatalWeblab that pulls treatments from Mons Weblab Task header. https://w.amazon.com/bin/view/Mons/Weblab/Configuration/
 */
var MonsWeblabTaskClient = /** @class */ (function (_super) {
    __extends(MonsWeblabTaskClient, _super);
    function MonsWeblabTaskClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param weblabs Array of weblabs
     * @returns Map of Weblab with its treatment
     */
    MonsWeblabTaskClient.prototype.getTreatments = function (weblabs) {
        var _this = this;
        return _super.prototype.verifySellerCentralWeblab.call(this, weblabs)
            .then(function () {
            var _a, _b;
            var metaElement = (_a = document === null || document === void 0 ? void 0 : document.head) === null || _a === void 0 ? void 0 : _a.querySelector('meta[name="a2z:mons_weblab_treatment"]');
            // eg: <meta name="a2z:mons_weblab_treatment" content="WEBLAB_1=T1,WEBLAB_2=C">
            var treatments = ((_b = metaElement === null || metaElement === void 0 ? void 0 : metaElement.content) === null || _b === void 0 ? void 0 : _b.split(',')) || [];
            var parsedTreatments = new Map();
            treatments.forEach(function (treatmentString) {
                // eg: treatmentString = 'WEBLAB_1=T1'
                var _a = treatmentString.split('=', 2), weblabId = _a[0], treatmentValue = _a[1];
                if (weblabId && treatmentValue) {
                    parsedTreatments.set(weblabId, treatmentValue);
                }
            });
            var treatmentMap = new Map();
            weblabs.map(function (weblab) {
                var parsedTreatment = parsedTreatments.get(weblab.id);
                var missingAssignment = !parsedTreatment;
                var treatment = parsedTreatment
                    ? parsedTreatment
                    : weblab.defaultTreatment;
                treatmentMap.set(weblab, _super.prototype.convertToTreatment.call(_this, weblab, treatment, missingAssignment));
            });
            return treatmentMap;
        });
    };
    return MonsWeblabTaskClient;
}(KatalWeblabSellerCentralClient_1.KatalWebSellerCentralClient));
exports.MonsWeblabTaskClient = MonsWeblabTaskClient;
